var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoginKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.498 3.5C7.424 3.5 2.5 7.354 2.5 12.105c0 3.093 2.086 5.806 5.218 7.321-.23.85-.832 3.08-.952 3.557-.15.592.22.585.46.423.191-.126 3.016-2.025 4.233-2.845.662.096 1.344.149 2.043.149 6.074 0 10.998-3.855 10.998-8.605S19.573 3.5 13.498 3.5z",
    fill: "#222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66 9.362c-.673 0-.673 1.165 0 1.165h1.146s.007 3.156 0 3.88c0 .53 1.193.556 1.19.027v-3.798s.391-.083 1.147-.083c.712 0 .712-1.194 0-1.194H5.659v.003zM11.289 10.818l.638 1.978h-1.33l.692-1.978zm-.716-.926c-.284.615-1.3 3.516-1.638 4.287-.244.556.81 1.01 1.057.453l.227-.794h2.1s-.074.034.207.761c.224.59 1.313.182 1.09-.407-.321-.84-1.438-3.87-1.639-4.3-.093-.199-.43-.341-.755-.341-.27 0-.532.1-.642.34M14.06 10.067c0 .986.007 4.165.007 4.165s-.09.632.454.632c.545 0 1.762-.007 2.3-.007.539 0 .535-1.134 0-1.134s-1.52-.007-1.52-.007.003-2.941 0-3.656c0-.344-.312-.52-.62-.52-.307 0-.62.176-.62.52M17.553 9.911c.014.434-.013 4.344-.013 4.635 0 .457 1.177.457 1.177 0v-1.538l.344-.275 1.511 2.042c.304.4 1.267-.321.96-.722l-1.605-2.09s1.09-1.165 1.518-1.588c.25-.245-.525-1.02-.776-.775-.244.239-1.949 1.93-1.949 1.93s.017-1.063 0-1.648c-.007-.222-.28-.331-.565-.331-.3 0-.612.122-.605.36",
    fill: "#F7E237"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginKakao);
export default __webpack_public_path__ + "static/media/icon_login_kakao.4da0fdf4bb877e9d07a692a05d66d7f9.svg";
export { ForwardRef as ReactComponent };